import { touchTexts } from "./texts";

export interface AttributionTouchView {
  source?: string | null;
  medium?: string | null;
  campaign?: string | null;
  content?: string | null;
  term?: string | null;
  link?: { title: string; deleted: boolean } | null;
  email?: {
    kind: string;
    automationName?: string | null;
    template?: string | null;
  } | null;
  capturedAt?: string | null;
  backfilled?: boolean | null;
}

const EMAIL_LABEL: Record<string, (name: string) => string> = {
  BROADCAST: touchTexts.broadcast,
  EVENT: touchTexts.event,
  JOURNEY: touchTexts.journey,
};

export function emailLabel(
  email: NonNullable<AttributionTouchView["email"]>
): string {
  if (email.kind === "TRANSACTIONAL")
    return touchTexts.transactional(email.template ?? "");
  const label = EMAIL_LABEL[email.kind];
  return email.automationName && label
    ? label(email.automationName)
    : touchTexts.deletedCampaign();
}

export function linkLabel(
  link: NonNullable<AttributionTouchView["link"]>
): string {
  return link.deleted
    ? touchTexts.linkDeleted(link.title)
    : touchTexts.linkValue(link.title);
}

/** Касание одной строкой для строки «Пришёл» в карточках. */
export function touchSummary(
  touch: AttributionTouchView | null | undefined
): string {
  if (!touch) return touchTexts.empty();
  const parts: string[] = [];
  if (touch.email) parts.push(emailLabel(touch.email));
  if (touch.link) parts.push(linkLabel(touch.link));
  const utm = [touch.source, touch.medium, touch.campaign]
    .filter(Boolean)
    .join(" / ");
  // У письма без ссылки UTM повторяют название письма: не дублируем.
  if (utm && (!touch.email || touch.link)) parts.push(utm);
  return parts.length ? parts.join(" · ") : touchTexts.empty();
}
